var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandlixL(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 227.3 185.5",
    style: {
      enableBackground: "new 0 0 227.3 185.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:#333333;}\n\t.st1{fill:#fff;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,0H111v185.5H59.4c-18.1,0-32.5-5.7-43.2-17.1S0,141.7,0,122.5c0-18,5.6-32.8,16.9-44.4 s25.7-17.4,43.2-17.4c8.1,0,17,1.7,26.6,5.2V0z M86.7,164.8V87.4c-7.5-3.8-15.1-5.7-22.8-5.7c-12,0-21.6,3.9-28.8,11.8 c-7.1,7.9-10.7,18.5-10.7,31.9c0,12.6,3.1,22.3,9.3,29.1c3.7,4.1,7.7,6.8,11.8,8.2c4.2,1.4,11.6,2.1,22.4,2.1L86.7,164.8L86.7,164.8 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.2,0h26.6v161.4h83.5v24.2H117.2V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlixL);
export default __webpack_public_path__ + "static/media/landlix-l.1de545d95c9d723e81bf45a0c5581b7c.svg";
export { ForwardRef as ReactComponent };